// Thông tin khách đã nhập trên /sale — NHẬP 1 LẦN, DÙNG LẠI Ở MỌI NƠI (đặt phòng, gọi lại, đặt lịch xem căn…).
// Nguyên tắc: hạn chế tối đa bắt khách gõ lại. Nơi nào cần thông tin đã có thì điền sẵn + HIỆN ra để khách thấy và sửa được.
// Lưu localStorage của THIẾT BỊ khách (không gửi đi đâu, không có tài khoản) — có nút "Xoá thông tin đã lưu".
import { readPrefJson, writePrefJson, removePref } from '@/lib/prefs';
import { todayISO } from '@/lib/utils';

const KEY = 'gms-sale-guest-v1';

export interface SaleGuestInfo {
  name?: string; phone?: string; email?: string; nationality?: string;
  from?: string; to?: string; adults?: number; children?: number;
}

export function readSaleGuest(): SaleGuestInfo {
  const v = readPrefJson<SaleGuestInfo>(KEY, {});
  return v && typeof v === 'object' ? v : {};
}

/** Gộp `patch` vào thông tin đã lưu. Giá trị rỗng ('' / undefined) = xoá trường đó (khách chủ động xoá ô). */
export function saveSaleGuest(patch: SaleGuestInfo): void {
  const next: Record<string, unknown> = { ...readSaleGuest() };
  for (const [k, v] of Object.entries(patch)) {
    if (v === undefined || v === '' || (typeof v === 'string' && !v.trim())) delete next[k]; else next[k] = typeof v === 'string' ? v.trim() : v;
  }
  writePrefJson(KEY, next);
}

export function clearSaleGuest(): void { removePref(KEY); }

/** Khoảng ngày đã lưu nếu còn hợp lệ (không ở quá khứ, trả sau nhận) — tránh điền sẵn ngày đã qua. */
export function storedStayDates(info: SaleGuestInfo = readSaleGuest()): { from: string; to: string } | null {
  const { from, to } = info;
  if (!from || !to || !/^\d{4}-\d{2}-\d{2}$/.test(from) || !/^\d{4}-\d{2}-\d{2}$/.test(to)) return null;
  return from >= todayISO() && to > from ? { from, to } : null;
}
